var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "artifact-block" },
    [
      _vm.isDownload
        ? _c(
            "a",
            {
              staticClass: "artifact-download",
              attrs: { href: _vm.url, download: "" },
            },
            [
              _c("i", { staticClass: "fas fa-file-download" }),
              _vm._v(
                "\n        " + _vm._s(_vm.strings.downloadFile) + "\n    "
              ),
            ]
          )
        : _vm.loading
        ? _c("div", { staticClass: "artifact-notice" }, [
            _c("i", { staticClass: "fas fa-spinner fa-spin" }),
            _vm._v(" " + _vm._s(_vm.strings.loadingResult) + "\n    "),
          ])
        : _vm.error
        ? _c("div", { staticClass: "artifact-notice is-error" }, [
            _c("i", { staticClass: "fas fa-exclamation-triangle" }),
            _vm._v(" " + _vm._s(_vm.error) + "\n    "),
          ])
        : _vm.payload
        ? [
            _vm.payload.title && _vm.payload.type !== "apexchart"
              ? _c("p", { staticClass: "artifact-title" }, [
                  _vm._v(_vm._s(_vm.payload.title)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.payload.note
              ? _c("p", { staticClass: "artifact-note" }, [
                  _vm._v(_vm._s(_vm.payload.note)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.payload.type === "datatable"
              ? _c("data-table", {
                  attrs: {
                    payload: _vm.payload.payload,
                    "filter-placeholder": _vm.strings.filterRows,
                    "showing-rows-text": _vm.strings.showingRows,
                  },
                })
              : _vm.payload.type === "apexchart"
              ? _c("chart-block", {
                  attrs: {
                    spec: _vm.chartSpec,
                    "error-text": _vm.strings.chartRenderError,
                    wide: true,
                  },
                })
              : _vm.payload.type === "map" &&
                _vm.payload.payload &&
                _vm.payload.payload.kind === "site"
              ? _c("site-map-block", {
                  attrs: {
                    payload: _vm.payload.payload,
                    "map-config": _vm.mapConfig,
                    strings: _vm.strings,
                  },
                })
              : _vm.payload.type === "map"
              ? _c("map-block", {
                  attrs: {
                    spec: _vm.chartSpec,
                    "error-text": _vm.strings.mapRenderError,
                    "no-points-text": _vm.strings.mapNoPoints,
                    "map-config": _vm.mapConfig,
                    wide: true,
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }